export default __webpack_public_path__ + "static/media/0.b55f9194.mp3";